// import { cookiePreferences } from "./cookie-consents";

const videoReferences = document.querySelectorAll(".js-video-play"),
    videosContainer = document.querySelector(".js-videos-container"),
    videosContainerInner = document.querySelector(
        ".js-videos-container__inner"
    ),
    aspectRatio = 9 / 16;

let videosReady = 0,
    videoArray = [];

export function init() {
    // Get all the videos ready
    load();

    // Pause/Close/Hide video events
    videosContainer.addEventListener("click", closeVideos);

    window.addEventListener("keydown", (e) => {
        const keyCode = e.keyCode;

        // If this is escape or enter, close the video
        if (keyCode === 27 || keyCode === 13) {
            closeVideos();
        }
    });
}

function resizeVideos() {
    // Resize all videos...
    let i = 0,
        video;

    for (i; i < videoArray.length; i++) {
        video = document.getElementById("lb_video_" + videoArray[i].videoId);

        if (typeof videoArray[i].vimeoPlayer !== "undefined") {
            video = video.querySelector("iframe");
        }

        if (video.style.display === "block") {
            let videoStyles = window.getComputedStyle(video, null),
                videoWidth = parseInt(
                    videoStyles.getPropertyValue("width"),
                    10
                );

            video.height = videoWidth * aspectRatio;
        }
    }
}

// Clone the video associated with each play link into the global videos container
function load() {
    let t;

    [...videoReferences].forEach((el, i) => {
        let videoId = el.dataset.videoid ? el.dataset.videoid : i.toString(),
            video = document.createElement("div"),
            youtubePlayer,
            vimeoPlayer,
            clonedVideoEmbed;

        // If this is not a direct vimeoId video initiate the player
        if (el.classList.contains("js-embed-video")) {
            const container = Utilities.findParentByClass(
                el,
                "page-section__image-container"
            );

            // Clone the video embed into the new video node we've just created
            clonedVideoEmbed = container
                .querySelector(".js-video-embed iframe")
                .cloneNode(true);

            clonedVideoEmbed.id = "lb_video_" + videoId;

            // Add this ID to the play link
            el.dataset.videoid = videoId;

            videosContainerInner.appendChild(clonedVideoEmbed);

            videoPlayerReady(el);
        } else {
            //  Add unique ID to this video element
            video.id = "lb_video_" + videoId;

            // Save video DOM element to global videos container
            videosContainerInner.appendChild(video);

            if (!isNaN(parseFloat(videoId)) && isFinite(videoId)) {
                let options = {
                    width: 1280,
                    id: videoId,
                };

                // if (!cookiePreferences.analytics) {
                //     options.dnt = true;
                // }

                vimeoPlayer = new Vimeo.Player(video, options);

                vimeoPlayer.ready().then(videoPlayerReady(el));
            } else {
                let options = {
                    width: "1280",
                    height: "720",
                    videoId: videoId,
                    events: {
                        onReady: youtubePlayerReady,
                    },
                };

                // if (!cookiePreferences.analytics) {
                //     options.host = "https://www.youtube-nocookie.com";
                // }

                // YouTube player
                youtubePlayer = new YT.Player(video, options);

                youtubePlayer.trigger = el;
            }
        }

        videoArray.push({
            videoId: videoId,
            vimeoPlayer: vimeoPlayer,
            youtubePlayer: youtubePlayer,
            otherPlayer: clonedVideoEmbed,
        });
    });

    // When all the videos are 'ready' force hide the container again
    t = setInterval(function () {
        if (videosReady === videoReferences.length) {
            clearInterval(t);

            videosContainer.classList.add("all-videos-ready");
        }
    }, 25);
}

function youtubePlayerReady(event) {
    videoPlayerReady(event.target.trigger);
}

function videoPlayerReady(el) {
    // Add click listener to this play link
    // Utilities.addEvent('click', el, LightboxVideos.playVideo);
    el.addEventListener("click", playVideo);

    // Add video-ready class to this play link
    el.classList.add("video-ready");

    videosReady++;
}

// Show overlay and play video
function playVideo(e) {
    e.preventDefault();

    let videoObj = videoArray.filter((obj) => {
            return obj.videoId === this.dataset.videoid;
        }),
        video = document.getElementById("lb_video_" + this.dataset.videoid);
    console.log(video);
    // Make sure all videos are hidden to start with
    let videoIframes = videosContainer.querySelectorAll("iframe");

    [...videoIframes].forEach((el) => {
        el.style.display = "none";
    });

    // Show and fadeIn video container
    videosContainer.classList.add("!opacity-100", "!pointer-events-auto");

    // setTimeout(function () {
    //     videosContainer.classList.add("visible");
    // }, 250);

    // The vimeo video iframe will actually be a child element so grab it
    if (typeof videoObj[0].vimeoPlayer !== "undefined") {
        video = video.querySelector("iframe");
    }

    console.log(video);

    video.style.display = "block";

    let videoStyles = window.getComputedStyle(video, null),
        videoWidth = parseInt(videoStyles.getPropertyValue("width"), 10);

    video.height = videoWidth * aspectRatio;

    if (typeof videoObj[0].vimeoPlayer !== "undefined") {
        videoObj[0].vimeoPlayer.play();
    } else if (typeof videoObj[0].youtubePlayer !== "undefined") {
        videoObj[0].youtubePlayer.playVideo();
    }
}

// Pause videos and hide page overlay
function closeVideos() {
    let i = 0;

    // Pause every video just in case
    for (i; i < videoArray.length; i++) {
        if (typeof videoArray[i].vimeoPlayer !== "undefined") {
            videoArray[i].vimeoPlayer.pause();
        } else if (typeof videoArray[i].youtubePlayer !== "undefined") {
            videoArray[i].youtubePlayer.pauseVideo();
        } else {
            // As a last ditch attempt let's try and force a pause command through
            videoArray[i].otherPlayer.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                "*"
            );
        }
    }

    // Fadeout overlay
    videosContainer.classList.remove("!opacity-100", "!pointer-events-auto");
}
